import { kevinAuthAPI } from 'apis/config';

export const itemApis = {
  itemList: (projectId) =>
    kevinAuthAPI.get(`/item/${projectId}`).then((res) => res.data),
  itemCreate: (projectId, data) =>
    kevinAuthAPI.post(`/item/${projectId}`, data).then((res) => res.data),
  itemDelete: (projectId, id) =>
    kevinAuthAPI.delete(`/item/${projectId}/${id}`).then((res) => res.data),
  itemUpdate: (projectId, id, data) =>
    kevinAuthAPI
      .patch(`/item/${projectId}/${id}`, data)
      .then((res) => res.data),
  itemUpdateImage: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/item/${projectId}/image/${id}`, data)
      .then((res) => res.data),
  itemUpdateIcon: (projectId, id, data) =>
    kevinAuthAPI
      .put(`/item/${projectId}/icon/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data),
};
